import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DocumentService } from 'src/app/core/services/document.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { DocumentActionService } from 'src/app/core/services/document-action-service';
import { StorageService } from 'src/app/core/services/storage.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-move-document-folder',
  templateUrl: './move-document-folder.component.html',
  styleUrls: ['./move-document-folder.component.css']
})
export class MoveDocumentFolderComponent implements OnInit {
  @ViewChild('documentFolderForm') documentFolderForm: NgForm;

  @Input() folder: any;
  @Input() document: any;
  @Input() parentFolders: any;
  @Input() allFolders: any;
  @Input() candidateType: any;
  @Input() candidateDetails: any;
  @Input() parentFolderName: any;
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();

  MESSAGECONSTANTS: any = MESSAGECONSTANTS;

  userId: any;
  savingFlag = false;
  context: string;
  documentFromFolderName: any;
  documentFromFolderParentName: any;

  constructor(
    private documentService: DocumentService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private documentActionService: DocumentActionService,
    private storageService: StorageService,
    private authService:AuthService
  ) { }

  ngOnInit() {
    this.userId = this.authService.getUserDetails().id;
    this.savingFlag = false;
    this.context = this.folder ? 'moveFolder' : 'moveDocument';
    if (this.document) {
      this.documentFromFolderName = this._getFolderName(this.document.folderId, 'folderName');
      this.documentFromFolderParentName = this._getFolderName(this.document.folderId, 'parentFolderName');
      this.documentActionService.setParentAndChildFolderName(this.allFolders, this.document);
    }
  }

  save() {
    if (this.context === 'moveFolder') {
      this._moveFolder();
    } else {
      this._moveDocument();
    }
  }

  private _moveFolder() {
    const folderToMove = this.folder;
    delete folderToMove.active;
    delete folderToMove.documents;
    delete folderToMove.folders;
    delete folderToMove.showActions;
    delete folderToMove.parentFolderName;
    if (!this.documentFolderForm.invalid) {
      this.savingFlag = true;
      if (this.folder.parentFolderId === 'root') {
        folderToMove.parentFolderId = null;
      }
      this.documentService.updateCandidateDocumentFolder(folderToMove, (data) => {
        this._setFolder(data);
      }, error => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  private _setFolder(folder) {
    this.folder = folder;
    this.savingFlag = false;
    if (this.saveCallback) {
      this.saveCallback.emit(this.folder);
    }
  }

  private _moveDocument() {
    if (!this.documentFolderForm.invalid) {
      this.savingFlag = true;
      this.document.shareDocument = this.document.shared;
      this.document.documentId = this.document.id;
      this.document.sharedEntityIds = this.document.shared ? this.document.sharedEntityIds.join(',') : null;
      this.document.candidateType = this.candidateType;
      this.document.userId = this.userId;
      this.document.fromFolderName = this.documentFromFolderName;
      this.document.fromFolderParentName = this.documentFromFolderParentName;
      this.document.toFolderName = this._getFolderName(this.document.folderId, 'folderName');
      this.document.toFolderParentName = this._getFolderName(this.document.folderId, 'parentFolderName');
      if (this.candidateDetails.jobMatchId) {
        this.document.jobMatchId = this.candidateDetails.jobMatchId;
      }

      this.documentService.updateCandidateDocumentData(this.document, (data) => {
        this.alertsAndNotificationsService.showBannerMessage('Document moved successfully.', 'success');
        if (this.saveCallback) {
          this.saveCallback.emit(this.document);
        }
      }, error => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
    }
  }

  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback.emit();
    }
  }

  private _getFolderName(folderId, name) {
    if (name === 'folderName') {
      return this.allFolders.filter(folder => folder.id === folderId)[0].name;
    } else {
      return this.allFolders.filter(folder => folder.id === folderId)[0].parentFolderName;
    }
  }

}
